import {Pipe, PipeTransform} from "@angular/core";
import {Product} from "./product";

@Pipe({
    name: 'sortProductsByParentProduct',
    standalone: false
})
export class SortProductsByParentProductPipe implements PipeTransform {

  transform(products: Product[], parentId: number): Product[] {
    let filteredProducts: Product[];
    filteredProducts = products.filter((product: Product): boolean => product.parentId && product.parentId == parentId);
    return filteredProducts;
  }

}
